module.exports = __webpack_public_path__ + "img/cloud-rainbow.90b2ce16.svg";